import React from 'react';
import { useTranslation } from 'react-i18next';
import { Trash2 } from 'lucide-react';
import { Separator } from '@/components/ui/separator';
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button';
import type { PredefinedPartLabel } from '@/types';
import { formatCADPosition } from '@/utils/cadCoordinates';

interface RegisteredPartLabelsListProps {
  labels: PredefinedPartLabel[];
  onDelete: (index: number) => void;
}

/** Read-out of the part labels staged for the current model, each removable. */
const RegisteredPartLabelsList: React.FC<RegisteredPartLabelsListProps> = ({
  labels,
  onDelete,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Separator />
      <p className="text-sm font-medium">
        {t('drbfm.cadLink.labelEditor.registered', '登録する部位')}
        {' '}
        ({labels.length})
      </p>
      {labels.length === 0 ? (
        <p className="text-sm text-muted-foreground">
          {t('drbfm.cadLink.labelEditor.empty', '登録済みの部位はありません')}
        </p>
      ) : (
        <ul className="max-h-[220px] overflow-auto">
          {labels.map((label, index) => (
            <li
              key={`${label.label}-${label.position.join(',')}`}
              className="flex items-center justify-between gap-2 border-b border-border py-2"
            >
              <div className="min-w-0">
                <p className="truncate text-sm">{label.label}</p>
                <p className="truncate text-sm text-muted-foreground">
                  {`${label.category} · ${formatCADPosition(label.position)}`}
                </p>
              </div>
              <TooltipIconButton
                size="icon-sm"
                label={`${t(
                  'drbfm.cadLink.labelEditor.delete',
                  '部位を削除',
                )}: ${label.label}`}
                icon={<Trash2 />}
                onClick={() => onDelete(index)}
              />
            </li>
          ))}
        </ul>
      )}
    </>
  );
};

export default RegisteredPartLabelsList;
